import { createContext } from 'react';

export const PreviewContext = createContext<PreviewContextProps>({
	isMenuOpen: false,
	setIsMenuOpen: () => {},
	toggleMenu: () => {},
});

interface PreviewContextProps {
	isMenuOpen: boolean;
	setIsMenuOpen: (value: boolean) => void;
	toggleMenu: Function;
}
